"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = void 0;

var _reverseFormatValue = require("./reverseFormatValue");

var _isNaN = _interopRequireDefault(require("lodash/isNaN"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var formatter = function formatter(value, decimalSeparator, thousandsSeparator) {
  var valueAsString = value.toString();
  var trimed = valueAsString.replace(/[,]{2,}/g, ',').replace(/[.]{2,}/g, '.');
  var isUsingComma = trimed.includes(',') && !trimed.includes('.');
  var decimalDivider = isUsingComma ? ',' : '.';

  var _trimed$split = trimed.split(decimalDivider),
      _trimed$split2 = _slicedToArray(_trimed$split, 2),
      integers = _trimed$split2[0],
      decimals = _trimed$split2[1];

  var spacedOutInterger = integers.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1".concat(thousandsSeparator));
  return trimed.includes(decimalDivider) ? "".concat(spacedOutInterger).concat(decimalSeparator).concat(decimals) : spacedOutInterger;
};

var round = function round(value, decimals) {
  var factorOfTen = Math.pow(10, decimals);
  return Math.round(value * factorOfTen) / factorOfTen;
};

var trailingCommaOrDot = function trailingCommaOrDot(value) {
  var lastChar = "".concat(value).slice(-1);
  return lastChar === ',' || lastChar === '.';
};

var formatNumber = function formatNumber(value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  var decimalSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var thousandsSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';

  if (!value && value !== 0 && value !== '') {
    return;
  } // Try parse number


  var num = Number((0, _reverseFormatValue.reverseFormatValue)(value));
  return !(0, _isNaN["default"])(num) && !trailingCommaOrDot(value) ? formatter(round(num, decimals), decimalSeparator, thousandsSeparator) : formatter(value, decimalSeparator, thousandsSeparator);
};

exports.formatNumber = formatNumber;